import camelcaseKeys from 'camelcase-keys';
import { useEffect, useState } from 'react';
import { getUnitSpecialFunctionsService } from '../services';

const useGetUnitSpecialFunctions = (
  unitId: number,
  fetch: boolean
): { specialFunctions: any; isFetching: boolean } => {
  const [specialFunctions, setSpecialFunctions] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);

  useEffect(() => {
    if (unitId && fetch) {
      setIsFetching(true);
      getUnitSpecialFunctionsService(
        {
          unitId
        },
        {
          successAction: (response) => {
            if (response?.success && response?.data && response?.data.length > 0) {
              const resultData = response.data.map((result) => camelcaseKeys(result));
              setSpecialFunctions(resultData);
            } else {
              setSpecialFunctions([]);
            }
            setIsFetching(false);
          },
          errorAction: (error) => {
            setSpecialFunctions([]);
            setIsFetching(false);
          }
        }
      );
    }
  }, [unitId, fetch]);

  return { specialFunctions, isFetching };
};

export default useGetUnitSpecialFunctions;
